import React from 'react';
import { Chip } from '@material-ui/core';
import WarningIcon from '@mui/icons-material/Warning';
import DescriptionIcon from '@mui/icons-material/Description';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Comisionist, PrimaryStatus, SecondaryStatus } from 'types/api/responses';
import { RenderIf } from 'components/Tools/Utils';

import {
  comisionistPrimaryStatusLabels,
  comisionistSecondaryStatusLabels,
  getComisionistPrimaryStatusStyle,
  getComisionistSecondaryStatusStyle,
  comisionistStatusChipSx,
} from './utils/statusStyles';

export function ComisionistPrimaryStatusChip({
  status,
  size = 'small',
}: {
  status: PrimaryStatus;
  size?: 'small' | 'medium';
}) {
  const style = getComisionistPrimaryStatusStyle(status);

  return (
    <Chip
      label={comisionistPrimaryStatusLabels[status]}
      size={size}
      style={{
        ...comisionistStatusChipSx,
        backgroundColor: style.backgroundColor,
        color: style.color,
        border: style.border,
      }}
    />
  );
}

export function ComisionistSecondaryStatusChip({
  comisionist,
  size = 'small',
  row = false,
}: {
  comisionist: Comisionist;
  size?: 'small' | 'medium';
  row?: boolean;
}) {
  // ponytail: verified===false overrides display to PendingVerification regardless of documentsStatus
  const status: SecondaryStatus = comisionist.documentsStatus;
  const style = getComisionistSecondaryStatusStyle(status);

  const icon =
    status === 'PendingDocuments' ? (
      <DescriptionIcon style={{ color: '#ffffff', fontSize: 16 }} />
    ) : status === 'DocsOK' ? (
      <CheckCircleIcon style={{ color: '#2e7d32', fontSize: 16 }} />
    ) : undefined;

  return (
    <div style={{ display: 'flex', flexDirection: row ? 'row' : 'column', alignItems: 'center', gap: 4 }}>
      <RenderIf condition={!comisionist.verified}>
        <Chip
/*           icon={<WarningIcon style={{ color: '#ffeb3b', fontSize: 12 }} />}
 */          label={comisionistSecondaryStatusLabels['PendingVerification']}
          size={size}
          style={{
            ...comisionistStatusChipSx,
            backgroundColor: getComisionistSecondaryStatusStyle('PendingVerification')
              .backgroundColor,
            color: getComisionistSecondaryStatusStyle('PendingVerification').color,
            border: getComisionistSecondaryStatusStyle('PendingVerification').border,
          }}
        />
      </RenderIf>
      <Chip
/*         icon={icon}
 */        label={comisionistSecondaryStatusLabels[status]}
        size={size}
        style={{
          ...comisionistStatusChipSx,
          backgroundColor: style.backgroundColor,
          color: style.color,
          border: style.border,
        }}
      />
    </div>
  );
}
